import React, { useEffect, useRef } from 'react';
import { View, TouchableOpacity } from 'react-native';
import throttle from 'lodash.throttle';
import { checkIntersectionObserver, getScrollParent, checkIsInViewWithBoundingRect } from './utils';
import { useRem } from '../../../hooks/useRem';
const hasIntersectionObserver = checkIntersectionObserver();
const IntersectionObserverView = (props) => {
    const { rootMargin, thresholds, onIntersectionChange, onInView, scalable } = props;
    const observeTargetRef = useRef(null);
    const exposureRef = useRef(false);
    const rem = useRem(scalable);
    const _onInView = () => {
        if (!exposureRef.current) {
            onInView === null || onInView === void 0 ? void 0 : onInView();
            exposureRef.current = true;
        }
    };
    // mount 时注册绑定事件
    useEffect(() => {
        var _a;
        const scrollEle = getScrollParent(observeTargetRef.current);
        let io;
        if (hasIntersectionObserver) {
            const intersectionHandler = (entries) => {
                if (!onIntersectionChange && !onInView) {
                    return;
                }
                entries.forEach((entry) => {
                    var _a;
                    onIntersectionChange === null || onIntersectionChange === void 0 ? void 0 : onIntersectionChange(entry);
                    if (entry.isIntersecting && observeTargetRef.current) {
                        _onInView();
                        (_a = io === null || io === void 0 ? void 0 : io.unobserve) === null || _a === void 0 ? void 0 : _a.call(io, observeTargetRef.current);
                    }
                });
            };
            // rootMargin 属性中数字转换成 IntersectionObserver 的属性值
            const _rootMargin = rootMargin
                ? `${rem(rootMargin.top)}px ${rem(rootMargin.right)}px ${rem(rootMargin.bottom)}px ${rem(rootMargin.left)}px`
                : '0px';
            io = new IntersectionObserver(intersectionHandler, {
                root: (scrollEle === window ? null : scrollEle),
                rootMargin: _rootMargin,
                threshold: thresholds,
            });
            if (observeTargetRef.current) {
                (_a = io === null || io === void 0 ? void 0 : io.observe) === null || _a === void 0 ? void 0 : _a.call(io, observeTargetRef.current);
            }
            return () => {
                var _a;
                if (observeTargetRef.current) {
                    (_a = io === null || io === void 0 ? void 0 : io.unobserve) === null || _a === void 0 ? void 0 : _a.call(io, observeTargetRef.current);
                }
            };
        }
        // 兼容不支持 IntersectionObserver
        const scrollHandler = throttle(() => {
            var _a;
            const isInView = observeTargetRef.current &&
                checkIsInViewWithBoundingRect(
                // @ts-ignore observeTargetRef 指定 HTMLElement类型时，与 TouchableOpacity的声明不太一致
                (_a = observeTargetRef.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect(), scrollEle);
            if (isInView) {
                _onInView();
                scrollEle.removeEventListener('scroll', scrollHandler);
            }
        }, 200, {
            trailing: true,
        });
        scrollEle.addEventListener('scroll', scrollHandler);
        scrollHandler();
        return () => {
            scrollEle.removeEventListener('scroll', scrollHandler);
        };
    }, [rootMargin, thresholds, onIntersectionChange, onInView]);
    return (props === null || props === void 0 ? void 0 : props.onPress) ? (React.createElement(TouchableOpacity, Object.assign({ ref: observeTargetRef, collapsable: false, activeOpacity: 1 }, props), props.children)) : (React.createElement(View, Object.assign({ ref: observeTargetRef, collapsable: false }, props), props.children));
};
export default IntersectionObserverView;
